<template>
    <div class="main-questions" >
        <div style="" class="top-questions px-3">

            <div class="title btn btn-primary text-white" @click.prevent="newQuestions = true">Hacer una pregunta</div>
        </div>
        <new-questions v-if="newQuestions" @close="newQuestions = false"></new-questions>
        <div>
            <get-all-questions></get-all-questions>
        </div>
    </div>

</template>

<script>
    import NewQuestions from "./NewQuestions.vue";
    import GetAllQuestions from "./GetAllQuestions.vue";
    import {mapState, mapGetters} from 'vuex'
    import axios from 'axios'
    export default {
        components: {
            GetAllQuestions,
            NewQuestions},
        name:'indexQuestions',
        created:function () {

        },
        data() {
            return {
                newMessage: '',
                newQuestions: false,
            }
        },

        methods: {

        }    
    }
</script>
<style scoped>
    .main-questions{
        display: flex;
        flex-direction: column;
        background-color: #F0F0F0;

        padding: 10px 5px;
    }
    .top-questions{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        padding-top: 10px;
        padding-bottom: 10px
    }
    .title{
        cursor: pointer;
        font-weight: 500; ;
        color: grey
    }
    .title:hover{
        color: #7465E4;
    }
</style>
